/* Shop This Look — add the whole curated look to cart in one request.
   Integrates with Minimog's cart drawer (renderContents + openCartDrawer). */
(function () {
  'use strict';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var fmt = (window.MinimogSettings && window.MinimogSettings.moneyFormat) || '${{amount}}';
    if (fmt.indexOf('{{amount}}') !== -1) return fmt.replace('{{amount}}', amount);
    if (fmt.indexOf('{{amount_no_decimals}}') !== -1) return fmt.replace('{{amount_no_decimals}}', Math.round(cents / 100));
    return '$' + amount;
  }

  function cartAddUrl() {
    if (window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.cart_add_url) {
      return window.MinimogSettings.routes.cart_add_url;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/cart/add.js';
  }

  function ShopTheLook(root) {
    this.root = root;
    this.discount = parseInt(root.getAttribute('data-discount'), 10) || 0;
    this.items = Array.prototype.slice.call(root.querySelectorAll('[data-stl-item]'));
    this.elTotal = root.querySelector('[data-stl-total]');
    this.elTotalDisc = root.querySelector('[data-stl-total-discounted]');
    this.elAddAllTotal = root.querySelector('[data-stl-addall-total]');
    this.btnAddAll = root.querySelector('[data-stl-add-all]');
    this.btnSave = root.querySelector('[data-stl-save-look]');
    this.elError = root.querySelector('[data-stl-error]');
    this.bind();
    this.recalc();
  }

  ShopTheLook.prototype.selectedFor = function (item) {
    var sel = item.querySelector('[data-stl-variant]');
    if (!sel) return null;
    var opt = sel.tagName === 'SELECT' ? sel.options[sel.selectedIndex] : sel;
    return {
      id: sel.value,
      price: parseInt(opt.getAttribute('data-price'), 10) || 0,
      available: (opt.getAttribute('data-available') || 'true') !== 'false'
    };
  };

  ShopTheLook.prototype.recalc = function () {
    var self = this;
    var total = 0;
    var addable = 0;
    this.items.forEach(function (item) {
      var v = self.selectedFor(item);
      if (!v) return;
      var priceEl = item.querySelector('[data-stl-price]');
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (v.available) { total += v.price; addable += 1; }
    });
    var discounted = Math.round(total * (100 - this.discount) / 100);
    if (this.elTotal) this.elTotal.textContent = formatMoney(total);
    if (this.elTotalDisc) this.elTotalDisc.textContent = formatMoney(discounted);
    if (this.elAddAllTotal) this.elAddAllTotal.textContent = formatMoney(this.discount > 0 ? discounted : total);
    this.btnAddAll.disabled = addable === 0;
    this.btnAddAll.querySelector('.stl__addall-label').textContent =
      addable === this.items.length ? 'Add all to cart' : 'Add ' + addable + ' available to cart';
  };

  ShopTheLook.prototype.collect = function (only) {
    var self = this;
    var items = [];
    (only ? [only] : this.items).forEach(function (item) {
      var v = self.selectedFor(item);
      if (v && v.available && v.id) items.push({ id: Number(v.id), quantity: 1 });
    });
    return items;
  };

  ShopTheLook.prototype.add = function (items, btn) {
    var self = this;
    if (!items.length) return;
    if (this.elError) this.elError.hidden = true;
    var original = btn.innerHTML;
    btn.disabled = true; btn.classList.add('is-loading');

    var drawer = document.querySelector('m-cart-drawer');
    var sections = [];
    try { if (drawer && drawer.getSectionsToRender) sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: sections.length ? sections : undefined, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { self.showError(res.description || res.message || 'Could not add to cart.'); return; }
        var useDrawer = drawer && window.MinimogSettings && window.MinimogSettings.enable_cart_drawer;
        if (useDrawer && drawer.renderContents) {
          try { drawer.renderContents(res); } catch (e) {}
          if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
            window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.openCartDrawer);
          }
        } else {
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          window.location.href = root.replace(/\/$/, '') + '/cart';
        }
      })
      .catch(function () { self.showError('Something went wrong. Please try again.'); })
      .then(function () { btn.disabled = false; btn.classList.remove('is-loading'); btn.innerHTML = original; self.recalc(); });
  };

  ShopTheLook.prototype.showError = function (msg) {
    if (!this.elError) return;
    this.elError.textContent = msg;
    this.elError.hidden = false;
  };

  // Save the look. Gated on account: logged-out shoppers are sent to create an
  // account (lead capture) before saving. Persistence of the saved look is
  // wired once the storage approach (customer metafield vs app) is chosen.
  ShopTheLook.prototype.saveLook = function () {
    var loggedIn = this.root.getAttribute('data-logged-in') === '1';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (!loggedIn) {
      window.location.href = root.replace(/\/$/, '') + '/account/register?return_url=' + encodeURIComponent(window.location.pathname);
      return;
    }
    this.btnSave.classList.add('is-saved');
    this.btnSave.childNodes[this.btnSave.childNodes.length - 1].textContent = ' Saved';
  };

  ShopTheLook.prototype.bind = function () {
    var self = this;
    this.items.forEach(function (item) {
      var sel = item.querySelector('select[data-stl-variant]');
      if (sel) sel.addEventListener('change', function () { self.recalc(); });
      var addOne = item.querySelector('[data-stl-add-one]');
      if (addOne) addOne.addEventListener('click', function () { self.add(self.collect(item), addOne); });
    });
    this.btnAddAll.addEventListener('click', function () { self.add(self.collect(), self.btnAddAll); });
    if (this.btnSave) this.btnSave.addEventListener('click', function () { self.saveLook(); });
  };

  function init() {
    document.querySelectorAll('[data-stl]').forEach(function (el) {
      if (!el.__stl) { el.__stl = new ShopTheLook(el); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
